import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SpinnerIcon } from '@/components/icons';
import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetTraitsQuery } from '@/services/endpoints/traits';
import { sortBy } from 'lodash';

interface ITraitValueProps {
  traitId: string;
}

export const TraitValue: FC<ITraitValueProps> = ({ traitId }) => {
  const { t } = useTranslation('audience');
  const workspace = useWorkspace();
  const { isLoading, data } = useGetTraitsQuery({
    workspaceId: workspace.id,
  });

  const customerTraits = data?.customer || [];
  const eventTraits = data?.event || [];
  const traits = useMemo(() => sortBy([...customerTraits, ...eventTraits], (e) => e.displayName), [customerTraits, eventTraits]);

  const renderTraitName = () => {
    return isLoading ? <SpinnerIcon className='ml-2 size-4' loading /> : traits.find((t) => t.id === traitId)?.displayName;
  };

  return (
    <p className='text-sm font-medium text-tertiary-600 first-letter:capitalize'>
      {t('rules.whose_property')} <span className='inline-block font-bold'>{renderTraitName()}</span>
    </p>
  );
};
